import React from "react";
import { FaTasks, FaCheckCircle, FaSpinner, FaClock } from "react-icons/fa";

const TaskStatsCards = ({ counts, onFilter }) => {
  const stats = [
    { label: "Total", value: counts.total, key: "All", color: "primary", icon: <FaTasks /> },
    { label: "Completed", value: counts.completed, key: "completed", color: "success", icon: <FaCheckCircle /> },
    { label: "Ongoing", value: counts.ongoing, key: "ongoing", color: "warning", icon: <FaSpinner /> },
    { label: "Pending", value: counts.pending, key: "pending", color: "danger", icon: <FaClock /> }
  ];

  return (
    <div className="row mb-4">
      {stats.map((item, index) => (
        <div className="col-md-3 col-sm-6 mb-3" key={index}>
          <div
            className="card shadow-sm p-3 hover-card"
            style={{ borderRadius: "12px", cursor: "pointer" }}
            onClick={() => onFilter(item.key)}
          >
            <div className="row align-items-center">
              {/* ICON COLUMN */}
              <div className="col-4 d-flex justify-content-center">
                <div className={`text-${item.color}`} style={{ fontSize: "38px" }}>
                  {item.icon}
                </div>
              </div>

              {/* TEXT COLUMN */}
              <div className="col-8 text-end">
                <h6 className="mb-1 text-muted">{item.label}</h6>
                <h3 className={`fw-bold text-${item.color}`} style={{ margin: 0 }}>
                  {item.value}
                </h3>
              </div>
            </div>
          </div>
        </div>
      ))}

      <style>{`
        .hover-card { transition: all 0.25s ease-in-out; }
        .hover-card:hover { transform: translateY(-4px); box-shadow: 0 6px 14px rgba(0,0,0,0.15); }
      `}</style>
    </div>
  );
};

export default TaskStatsCards;
